import React, {useEffect, useRef, useState} from 'react';
import {View, Image as ImageComponent, Platform} from 'react-native';
import styled from 'styled-components/native';
import {
  ContentRevision,
  withContentRevalidation,
  withContentRevision,
} from '../../utils/contentAssetUrl';

const ImageWrapper = styled(View)`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  overflow: hidden;
  width: 50px;
  height: 50px;
  align-self: flex-start;
`;

const Image = styled(ImageComponent)`
  flex-grow: 1;
`;

interface ImageIconProps {
  source: {uri: string};
  revision?: ContentRevision;
}

const IMAGE_REVALIDATION_DELAY = 4000;

const ImageIcon = ({source, revision}: ImageIconProps) => {
  const loadToken = useRef(Date.now().toString()).current;
  const [revalidationAttempt, setRevalidationAttempt] = useState(0);
  const versionedUri =
    Platform.OS === 'web'
      ? withContentRevision(source.uri, revision)
      : source.uri;
  const imageUri =
    Platform.OS === 'web'
      ? withContentRevalidation(
          versionedUri,
          loadToken,
          revalidationAttempt,
        )
      : versionedUri;

  useEffect(() => {
    if (Platform.OS !== 'web') {
      return undefined;
    }

    setRevalidationAttempt(0);
    const timer = window.setTimeout(
      () => setRevalidationAttempt(1),
      IMAGE_REVALIDATION_DELAY,
    );

    return () => window.clearTimeout(timer);
  }, [source.uri, revision]);

  return (
    <ImageWrapper>
      <Image source={{...source, uri: imageUri}} />
    </ImageWrapper>
  );
};

export default ImageIcon;
